import React, { Component } from "react";
import { connect } from "react-redux";
import LoginOtp from "../components/register";
import { close_snack_bar } from "../../common/snackbar/action";
import { clear_login, register_user } from "../actions";

export class Controller extends Component {
  render() {
    return <LoginOtp {...this.props} />;
  }
}

export const mapStateToProps = store => ({
  login: store.login,
  loader: store.loader,
  snackbar: store.snackbar,
});

export const mapDispatchToProps = dispatch => ({
  clear_login: () => dispatch(clear_login()),
  close_snack_bar: () => dispatch(close_snack_bar()),
  register_user: (name, aadhar, dob, mobile) => dispatch(register_user(name, aadhar, dob, mobile)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Controller);
